// src/services/api.ts
  export const fetchPhoneNumber = async (selectedCountry: string) => {
    const response = await fetch("https://lost-abroad.herokuapp.com/mini/get_phone_number/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ country: selectedCountry }),
    });
    const data = await response.json();
    return data;
  };
  
  export const fetchNumberInRange = async (min_num: number, max_num: number, country: string) => {
    console.log('starting fetch number');
    const response = await fetch("https://lost-abroad.herokuapp.com/mini/get_num_in_range/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ min_num, max_num, country }),
    });
    const data = await response.json();
    console.log(data);
    return data; // Contains rnum and spokenurl
  };
  
  export const fetchMathProblem = async (min_num: number, max_num: number, country: string, difficulty: string) => {
    const response = await fetch("https://lost-abroad.herokuapp.com/mini/get_math_problem/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ min_num, max_num, country, difficulty }),
    });
    const data = await response.json();
    return data; // Contains answer and spokenurl
  };

  export const fetchTimeofDay = async (selectedCountry: string) => {
    const response = await fetch("https://lost-abroad.herokuapp.com/mini/get_time_of_day/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ country: selectedCountry }),
    });
    const data = await response.json();
    return data;
  };